<template>
  <div ref="wrapper" class="position-relative wrapper" :style="wrapperStyle">
    <div v-if="state === 'loading'" class="preview-skeleton">
      <skeleton-rectangle></skeleton-rectangle>
    </div>
    <div v-else-if="state === 'error' || (state === 'loaded' && !results.length)">
      <div class="centered-text">
        <cool-label>No preview available</cool-label>
      </div>
    </div>
    <!-- make frame invisible until it's sized, otherwise it'll flicker onto the screen full-sized and nobody wants to see that -->
    <iframe v-else class="frame" :class="{ 'invisible': state !== 'ready' }" ref="frame" :srcdoc="adMarkup" frameBorder="0" marginwidth="0" marginheight="0" @load="resizeToFit"></iframe>
  </div>
</template>

<style scoped>
.wrapper {
  min-height: 3em;
}
.preview-skeleton {
  position: absolute;
  top: 0.5em;
  left: 0.5em;
  right: 0.5em;
  bottom: 0.5em;
}
.frame {
  position: absolute;
  left: 50%;
  top: 50%;
}
.centered-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
</style>

<script>
import SkeletonRectangle from '@/components/SkeletonRectangle'
import { ReportsApi } from '@/reports/api'

export default {
  props: {
    height: { type: String, default: '100%' },
    width: { type: String, default: '100%' },
    partner: { required: false, type: String }, //partner name
    cid: { required: false, type: String }, //campaign id
    crid: { required: false, type: String }, //creative id
    adm: { required: false, type: String }
  },
  data () {
    return {
      results: [],
      state: ''
    }
  },
  created () {
    if (this.adm === undefined) {
      this.getAdMarkup()
    }
    this.$nextTick(function() {
      window.addEventListener('resize', this.resizeToFit);
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeToFit);
  },
  methods: {
    resizeToFit () {
      this.$nextTick(() => {
        // frame.width = frame.contentWindow.document.body.scrollWidth
        // frame.height = frame.contentWindow.document.body.scrollHeight

        let wrapper = this.$refs.wrapper
        let wrapperWidth = wrapper.offsetWidth
        let wrapperHeight = wrapper.offsetHeight
        let frame = this.$refs.frame
        let frameWidth = frame.contentDocument.body.scrollWidth
        let frameHeight = frame.contentDocument.body.scrollHeight

        let widthPercent = wrapperWidth/frameWidth
        let heightPercent = wrapperHeight/frameHeight

        if (!frame) {
          return
        }
        frame.contentDocument.body.style.overflow = 'hidden'

        if (widthPercent < heightPercent) {
          frame.style.transform = 'scale(' + widthPercent + ') translate(-50%, -50%)';
        } else {
          frame.style.transform = 'scale(' + heightPercent + ') translate(-50%, -50%)';
        }
        frame.style.transformOrigin = 'top left'
        frame.style.width = frameWidth + 'px'
        frame.style.height = frameHeight + 'px'
        this.state = 'ready'
        frame.style.visibility = 'visible'
      })
    },
    getAdMarkup () {
      if (this.partner && this.cid && this.crid) {
        this.state = 'loading'
        ReportsApi.bqreport(this.query, this).then((data) => {
          this.state = 'loaded'
          this.results = data.results
        }).catch((err) => {
          this.state = 'error'
        })
      } else {
        this.state = 'error'
      }
      
    }
  },
  computed: {
    adMarkup () {
      if (this.adm === undefined) {
        if (this.results.length > 0)
          return this.results[0].bid_adm
      } else {
        return this.adm
      }
    },
    query () {
      return {
        dateAsMillis: true,
        fields: ['bid_adm'],
        filters: [
          {
            field: 'demand_partner',
            operator: 'EQUAL',
            value: this.partner
          },
          {
            field: 'bid_cid',
            operator: 'EQUAL',
            value: this.cid
          },
          {
            field: 'bid_crid',
            operator: 'EQUAL',
            value: this.crid
          },
        ],
        stats: [],
        timezone: 'UTC',
        limit: 1
      }
    },
    wrapperStyle () {
      return 'height: ' + this.height + '; width: ' + this.width + ';'
    }
  },
  components: {
    SkeletonRectangle
  }
}
</script>


// WEBPACK FOOTER //
// src/components/preview/LiveAdPreview.vue